'use client';

import { RouteErrorView } from '@/components/route-error-view';

interface ErrorBoundaryProps {
	error: Error & { digest?: string };
	reset: () => void;
}

/**
 * Marketing and public-page boundary. Visitors here are never signed in, so a
 * crash would otherwise escalate to the root global-error screen and lose the
 * route context entirely.
 */
const ErrorBoundary = ({ error, reset }: ErrorBoundaryProps) => (
	<RouteErrorView
		error={error}
		reset={reset}
		title="This page could not load"
		description="Something went wrong. Try again, or go back."
	/>
);

export default ErrorBoundary;
